import { PartStyles } from "@/types/design";
import { Result } from "@/types/result";
import { fetcher } from "@/utils/fetcher";
import BaseService from "./baseService";

/**
 * Design サービス
 */
export default class DesignService extends BaseService {
	// TODO:型、トークンの形式
	/**
	 * デザインを取得します。
	 * @param params パラメーター
	 * @returns パーツ
	 */
	async GetDesign(bodyId: string): Promise<Result<null, Error>> {
		return await fetcher.get<any>(
			this.url(`/design/get/${bodyId}`),
			this.token,
		);
	}

	/**
	 * デザインを取得します。
	 * @param params パラメーター
	 * @returns パーツ
	 */
	async GetDesigns(): Promise<Result<null, Error>> {
		return await fetcher.get<any>(this.url(`/design/get`), this.token);
	}

	/**
	 * デザインを作成します。
	 * @returns パーツ
	 */
	async Create(body: PartStyles): Promise<Result<null, Error>> {
		return await fetcher.post(this.url(`/design/create`), body, this.token);
	}

	/**
	 * デザインを更新します。
	 * @param body リクエストボディ
	 * @returns パーツ
	 */
	async Update(body: {
		bodyId: string;
		partStyles: PartStyles;
	}): Promise<Result<null, Error>> {
		const { bodyId } = body;
		return await fetcher.patch(
			this.url(`/design/update/${bodyId}`),
			body,
			this.token,
		);
	}
}
